<template>
  <v-row
      v-if="currentPermission.privilegeLevel != 'admin'"
      align="center"
      justify="center"
  >
    <v-col cols="12" sm="8" md="5">
      <v-card outlined>
        <v-card-text>
          <div class="text-center">
            <v-icon color="grey lighten-2" size="85">mdi-shield-remove</v-icon>
          </div>
          <div
              class="mt-2 text-center text--primary text-h6 font-weight-regular"
          >
            Business Profile Deactivated
          </div>
          <div class="text-center">
            Oops! It looks like this business profile has been deactivated.
          </div>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-btn
              width="150"
              @click="handeRedirectToBusinessAccounts"
              color="primary"
              block
              depressed
              large
              class="text-body-1"
          >{{
              loggedInUsersPermissions.length > 1
                  ? "Select another business profile"
                  : "Create new business profile"
            }}
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  <v-row v-else align="center" justify="center">
    <v-col cols="12" sm="8" md="5">
      <v-dialog v-model="loadingDialog" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            {{ loadingMessage }}
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--Start: Select Plan Dialog -->
      <v-dialog v-model="selectPlanDialog">
        <v-card>
          <v-card-title class="pb-0">
            Choose the right plan for your business
          </v-card-title>
          <v-card-text class="pt-0 pb-0">
            <v-container>
              <v-row>
                <v-col cols="6">
                  <PlanContainer
                      plan="grow"
                      :isYearly="billingPeriod == 'yearly'"
                  >
                    <v-btn
                        v-if="selectedPlan == 'grow'"
                        outlined
                        disabled
                        width="250"
                        color="primary"
                        large
                        elevation="0"
                    >Current Plan
                    </v-btn
                    >
                    <v-btn
                        v-else
                        outlined
                        width="250"
                        color="primary"
                        @click="selectGrowPlan"
                        large
                        elevation="0"
                    >Select plan
                    </v-btn
                    >
                  </PlanContainer>
                </v-col>
                <v-col cols="6">
                  <PlanContainer
                      plan="evolve"
                      :isYearly="billingPeriod == 'yearly'"
                  >
                    <v-btn
                        v-if="selectedPlan == 'evolve'"
                        outlined
                        disabled
                        width="250"
                        color="primary"
                        large
                        elevation="0"
                    >Current Plan
                    </v-btn
                    >
                    <v-btn
                        v-else
                        outlined
                        width="250"
                        color="primary"
                        @click="selectEvolvePlan"
                        large
                        elevation="0"
                    >Select plan
                    </v-btn
                    >
                  </PlanContainer>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- End: Select Plan Dialog -->
      <v-tabs-items
          class="transparent"
          v-model="tab"
          align-center
          justify-center
      >
        <v-tab-item eager>
          <v-card outlined>
            <!-- <v-card-title
              v-if="
                loggedInUsersPermissions.length == 1 &&
                (this.businessProfile.businessName || '') == ''
              "
              >Successfully verified!</v-card-title
            > -->
            <v-card-title
                v-if="businessProfile.subscriptionStatus == 'canceled'"
            >Restart Subscription
            </v-card-title
            >
            <v-card-title v-else>Business Profile</v-card-title>
            <v-card-subtitle
            >Please tell us about your business to complete your account
              set-up.
            </v-card-subtitle
            >
            <v-form
                ref="initialBusinessProfileForm"
                v-model="valid"
                @submit.prevent="saveInitialBusinessProfile"
            >
              <v-card-text class="pb-0">
                <v-text-field
                    label="Business Name"
                    name="businessName"
                    prepend-inner-icon="work"
                    outlined
                    type="text"
                    v-model="businessName"
                    :rules="businessNameRules"
                    required
                    :validate-on-blur="isFirstSubmissionAttempt"
                    hint="e.g. Pappyon Pty Ltd"
                ></v-text-field>
                <v-text-field
                    class="mt-4"
                    label="Registered Business Number"
                    name="businessNumber"
                    prepend-inner-icon="tag"
                    outlined
                    type="text"
                    v-model="businessNumber"
                    :rules="businessNumberRules"
                    required
                    :validate-on-blur="isFirstSubmissionAttempt"
                    hint="ABN, NZBN, or similar"
                ></v-text-field>

                <v-autocomplete
                    class="mt-4"
                    label="Business Category"
                    name="businessCategory"
                    prepend-inner-icon="mdi-domain"
                    outlined
                    v-model="businessCategory"
                    :rules="businessCategoryRules"
                    :items="businessCategoryList"
                    placeholder="Business Category"
                    required
                ></v-autocomplete>

                <v-autocomplete
                    class="mt-4"
                    label="Country"
                    name="businessLocation"
                    prepend-inner-icon="location_on"
                    outlined
                    v-model="businessLocation"
                    :rules="businessLocationRules"
                    :items="countryList"
                    placeholder="Start typing..."
                    required
                ></v-autocomplete>

                <v-text-field
                    v-if="!isPartnerRepresentative()"
                    class="mt-4"
                    label="Team Size"
                    hint="Total number of members/employees to be issued a business card."
                    name="noOfEmployees"
                    prepend-inner-icon="people"
                    outlined
                    v-model="noOfEmployees"
                    :rules="noOfEmployeesRules"
                    required
                    :validate-on-blur="isFirstSubmissionAttempt"
                    autocomplete="new-password"
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="px-4 pb-3">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-btn
                        elevation="0"
                        block
                        type="submit"
                        color="primary"
                        large
                        class="text-body-1"
                    >{{ isPartnerRepresentative() ? "Done" : "Continue" }}
                    </v-btn
                    >
                  </v-col>
                  <!-- Start: Existing (Canceled) Business Profile -->
                  <template
                      v-if="(businessProfile.stripeCustomerId || '') != ''"
                  >
                    <v-col
                        v-if="filteredLoggedInUsersPermissions.length >= 2"
                        cols="12"
                        class="mt-2"
                    >
                      <v-btn
                          outlined
                          elevation="0"
                          block
                          to="/businessAccounts"
                          color="primary"
                          large
                          class="mt-2 text-body-1"
                      >Choose another business profile
                      </v-btn
                      >
                    </v-col>
                    <v-col
                        v-if="filteredLoggedInUsersPermissions.length >= 2"
                        cols="12"
                        class="mt-2"
                    >
                      <v-btn
                          outlined
                          elevation="0"
                          block
                          to="/businessAccounts?create=true"
                          color="primary"
                          large
                          class="mt-2 text-body-1"
                      >Create a new business profile
                      </v-btn
                      >
                    </v-col>
                  </template>
                  <!-- End: Existing (Canceled) Business Profile -->
                  <v-col
                      v-else-if="filteredLoggedInUsersPermissions.length > 0"
                      cols="12"
                  >
                    <v-btn
                        text
                        elevation="0"
                        block
                        to="/businessAccounts"
                        color="primary"
                        large
                        class="mt-2 text-body-1"
                    >Cancel
                    </v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-tab-item>
        <v-tab-item :eager="true">
          <!--Start: New layout for add on subscription module-->
          <v-card outlined>
            <v-card-title v-if="getTrialPeriodDays > 0">
              Confirm your business plan for your
              {{ getTrialPeriodDays }}-day free trial
            </v-card-title>
            <v-card-title v-else> Confirm your business plan</v-card-title>
            <v-card-subtitle>
              No charges will be applied until your free trial ends on
              {{ freeTrialEndDate }}
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-sheet
                      class="d-flex"
                      color="#F6F6F6"
                      style="border-radius: 9px"
                  >
                    <v-sheet
                        width="50%"
                        @click="billingPeriod = 'monthly'"
                        height="40"
                        :color="
                        billingPeriod == 'monthly' ? '#FDE1D6' : '#F6F6F6'
                      "
                        class="d-flex justify-center align-center cursor-pointer"
                        style="border-radius: 9px"
                    >
                      <div
                          :class="[
                          'text-center',
                          {
                            'primary--text font-weight-bold':
                              billingPeriod == 'monthly',
                          },
                        ]"
                      >
                        Monthly
                      </div>
                    </v-sheet>
                    <v-sheet
                        height="40"
                        width="50%"
                        class="d-flex justify-center align-center cursor-pointer"
                        :color="billingPeriod == 'yearly' ? '#FDE1D6' : '#F6F6F6'"
                        @click="billingPeriod = 'yearly'"
                        style="border-radius: 9px"
                    >
                      <div
                          :class="[
                          'text-center',
                          {
                            'primary--text  font-weight-bold':
                              billingPeriod == 'yearly',
                          },
                        ]"
                      >
                        Annually &ensp;
                        <span class="primary--text text-caption ml-2"
                        >(save 20%)</span
                        >
                      </div>
                    </v-sheet>
                  </v-sheet>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <div class="text-subtitle-2">Your Plan</div>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-2">
                      Total number of business cards
                    </div>
                    <div class="text-subtitle-2">
                      <v-form ref="businessSubscriptionForm">
                        <v-text-field
                            class="right-aligned-input"
                            v-model="noOfEmployees"
                            style="width: 100px; text-align: center"
                            dense
                            outlined
                            :rules="noOfBusinessCardsRules"
                            required
                        ></v-text-field>
                      </v-form>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-2">
                      Base Rate (includes 1 team member)
                    </div>
                    <div class="text-subtitle-2 text-right">
                      <span class="text-body-1 font-weight-bold">
                        {{ basePriceToPreview.format() }}</span
                      >
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" class="pb-0">
                  <div class="d-flex justify-space-between">
                    <div class="text-subtitle-2">
                      Additional team members x
                      {{ this.additionalBusinessCards }}
                    </div>
                    <span class="text-body-1 font-weight-bold">{{
                        plan.perCardPrice
                            .multiply(this.additionalBusinessCards)
                            .format()
                      }}</span>
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-2">Optional inclusion</div>
                </v-col>
                <v-col cols="12">
                  <v-list-item
                      three-line
                      class="rounded-lg"
                      style="background-color: #fef3ee"
                      @click="handleInclusionClick"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary">{{ inclusionIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                      >EventConnect
                      </v-list-item-title
                      >
                      <v-list-item-subtitle>
                        Create attendee connection links for all of your events
                        (unlimited).
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                          class="text-decoration-underline mt-2"
                          @click.stop="showMCVideo = true"
                      >
                        Watch video
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="font-weight-medium">
                      {{ mcAddOnRate.format() }}
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item
                      three-line
                      class="rounded-lg mt-4"
                      style="background-color: #fef3ee"
                      @click="handleCRMInclusionClick"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary">{{ crmInclusionIcon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                      >CRM Integration
                      </v-list-item-title
                      >
                      <v-list-item-subtitle>
                        By selecting this option, a request will be sent to
                        Pappyon and they will be in touch with you.
                      </v-list-item-subtitle>
                      <v-list-item-subtitle
                          class="text-decoration-underline mt-2"
                      >
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <!-- <v-col class="my-0 py-0">
                  <div class="text-subtitle-2 text-right">
                    <span class="text-body-1 font-weight-bold">{{
                      selectedPlan == "grow" ? "Grow" : "Evolve"
                    }}</span>
                    (<span class="text-subtitle-2 text-decoration-underline"
                      ><a @click="selectPlanDialog = true">Change Plan</a></span
                    >)
                  </div>
                </v-col> -->
              </v-row>

              <v-slide-y-transition>
                <v-row
                    v-if="
                    promoCodeObject != null &&
                    promoCodeObject.coupon.percent_off / 100 >
                      volumeDiscount.ratio
                  "
                    class="mt-2 my-0 py-0"
                    align="center"
                    justify="center"
                >
                  <v-col class="my-0 py-0">
                    <p class="text-subtitle-2">
                      {{ promoCodeObject.coupon.name }}
                      <a
                          @click="removePromoCode()"
                          class="
                          primary--text
                          text-subtitle-2 text-decoration-underline
                          ml-1
                        "
                      >Remove</a
                      >
                    </p>
                  </v-col>
                  <v-col class="my-0 py-0">
                    <div class="text-subtitle-2 text-right">
                      <span class="text-body-1 font-weight-bold"
                      >- {{ discountAmount.format() }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
                <v-row
                    v-else-if="volumeDiscount.percent > 0"
                    class="mt-2 my-0 py-0"
                    align="center"
                    justify="center"
                >
                  <v-col class="my-0 py-0">
                    <p class="text-subtitle-2">
                      Volume Discount
                      <span v-if="volumeDiscount.endInterval != -1"
                      >- {{ addCommas(volumeDiscount.startInterval) }} to
                        {{ addCommas(volumeDiscount.endInterval) }}
                        cards<br/></span
                      >({{ volumeDiscount.percent }}% off)
                    </p>
                  </v-col>
                  <v-col class="my-0 py-0">
                    <div class="text-subtitle-2 text-right">
                      <span class="text-body-1 font-weight-bold"
                      >- {{ discountAmount.format() }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-slide-y-transition>
              <v-row
                  v-if="businessProfile.country == 'Australia'"
                  class="mt-2 my-0 py-0"
                  align="center"
                  justify="center"
              >
                <v-col class="my-0 py-0">
                  <p class="text-subtitle-2">GST @ 10%</p>
                </v-col>
                <v-col class="my-0 py-0">
                  <div class="text-subtitle-2 text-right">
                    <span class="text-body-1 font-weight-bold">{{
                        gst.format()
                      }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row class="my-0 py-0">
                <v-col class="my-0 py-0" v-if="promoCodeObject === null">
                  <p class="text-subtitle-2 text-decoration-underline mb-0">
                    <a @click="presentpromoCodeDialog()">Add promo code</a>
                  </p>
                </v-col>
                <v-dialog v-model="promoCodeDialog" width="350">
                  <v-card :loading="this.promoCodeLoading">
                    <v-card-title>Add promo code</v-card-title>
                    <v-card-text class="mt-5">
                      <v-alert
                          dense
                          text
                          prominent
                          color="primary"
                          v-if="promoServerError != ''"
                      >
                        <v-row align="center">
                          <v-col class="grow">{{ promoServerError }}</v-col>
                        </v-row>
                      </v-alert>
                      <v-text-field
                          v-model="promoCode"
                          outlined
                          prepend-inner-icon="local_offer"
                      ></v-text-field>
                      <v-btn
                          class="mt-2 text-body-1"
                          block
                          color="primary"
                          large
                          elevation="0"
                          @click="applyPromoCode"
                      >Apply Code
                      </v-btn
                      >
                      <v-btn
                          block
                          text
                          color="primary"
                          large
                          class="mt-2 text-body-1"
                          @click="promoCodeDialog = false"
                      >Cancel
                      </v-btn
                      >
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
              <!-- <v-divider/> -->
              <v-row class="py-0">
                <v-col class="my-0 py-0">
                  <p class="text-h6 text--primary"></p>
                  <v-list-item two-line class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium"
                      >Total due {{ freeTrialEndDate }}
                      </v-list-item-title
                      >
                      <v-list-item-subtitle>
                        No charges will be applied today
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action
                        class="font-weight-medium d-inline-block"
                    >
                      <span class="text-body-2 font-weight-bold text-right">{{
                          totalPrice.format()
                        }}</span>
                      /
                      {{ billingPeriod == "monthly" ? "month" : "year" }}
                    </v-list-item-action>
                  </v-list-item>
                </v-col>
                <!-- <v-col class="my-0 py-0">
                  <div class="text-right text--primary"></div>
                </v-col> -->
              </v-row>
              <div
                  class="mt-2 py-5 px-2"
                  style="border: 1px solid #9e9e9e; border-radius: 8px"
              >
                <div ref="cardElement"></div>
              </div>
              <div class="text-caption error--text">
                {{ cardError }}
              </div>
              <v-btn
                  elevation="0"
                  block
                  @click="handleSubscribe"
                  color="primary"
                  large
                  class="mt-5 text-body-1"
              >Subscribe
              </v-btn
              >
              <v-btn
                  text
                  elevation="0"
                  block
                  @click="handleBackClick"
                  color="primary"
                  large
                  class="mt-2 text-body-1"
              >Back
              </v-btn
              >
              <v-dialog v-model="billingPeriodDialog" width="500">
                <v-card>
                  <v-card-title> Switch to Yearly and save 20%!</v-card-title>
                  <v-card-text class="mt-5">
                    <div class="text-center text-body-2 text--secondary">
                      <span
                          class="
                          font-weight-regular
                          text-h5 text-decoration-line-through
                        "
                      >{{ totalPrice.multiply(12).format() }} / year</span
                      ><br/>
                      <span class="text-body-1"
                      >({{ totalPrice.format() }} / month)</span
                      ><br/>
                      <br/>
                      <span class="font-weight-regular text-h5"
                      >{{ calculateYearlyPrice().format() }} / year</span
                      ><br/>
                      <span class="text-body-1"
                      >(equivalent to
                        {{ calculateYearlyPrice().divide(12).format() }}
                        / month)</span
                      >
                    </div>
                    <!-- <p class="text-center text-h4"><span class="text--primary">$ {{ addCommas(((totalPrice * 12) - (totalPrice * 12 * 0.2))) }}</span><br/><span class="font-weight-thin">per year</span></p> -->
                    <v-btn
                        class="mt-10 text-body-1"
                        block
                        color="primary"
                        large
                        elevation="0"
                        @click="switchToYearly"
                    >Switch to Yearly Billing Now
                    </v-btn
                    >
                    <v-btn
                        block
                        text
                        color="primary"
                        large
                        class="mt-2 text-body-1"
                        @click="subscribe"
                    >Continue with Monthly Billing
                    </v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>

          <MultiConnectVideo :show="showMCVideo" @close="showMCVideo = false"/>
          <!--End: New layout for add on subscription module-->
        </v-tab-item>
        <!-- <v-tab-item>
                    <v-card outlined>
                        <v-card-title>Welcome to Pappyon, {{ businessProfile.businessName }}!</v-card-title>
                        <v-card-subtitle>Great business networking needs a great looking business card. Start customizing your card design.</v-card-subtitle>
                        <v-card-text>
                            <lottie-animation path="Animation_6.json"/>
                        </v-card-text>
                        <v-card-actions class="px-4 pb-3">
                            <v-row no-gutters>
                                <v-col cols=12>
                                    <v-btn elevation="0" to="/onboard/0" block color="primary" large class="text-body-1">Start Customizing</v-btn>
                                </v-col>
                                <v-col cols=12>
                                    <v-btn to="/" block text color="primary" large class="mt-3 text-body-1">Skip for now</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-tab-item> -->
      </v-tabs-items>
    </v-col>
  </v-row>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import Utility from "@/shared/utility";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import * as currency from "currency.js";
import PlanContainer from "@/components/PlanContainer";
import MultiConnectVideo from "@/components/MultiConnect/MultiConnectVideo";
import EventTrigger from "@/models/EventTrigger";
import constants from "@/shared/constants";
import axios from "axios";
import {
  getCollectionRef, getDocById,
  getHttpsCallable,
  getQueryBusinessCardsCollection,
  getQueryByCollectionName, updateBusinessCardsDoc,
  updateDocByName, updateUserDoc
} from "@/shared/firebase_utils";
import {doc, getFirestore, where, writeBatch} from "firebase/firestore";

let stripe = Stripe(
    process.env.NODE_ENV == "production"
        ? "pk_live_51H57KKAb8fzN3Ilf9WjqI74BNpQmDCLJ5BdPu1XwMVIxjPdpJ21ZWKAIC0c0IOWkiHMcQ8XcWk9222zodr65ujKm00PucB5bqX"
        : "pk_test_51H57KKAb8fzN3IlflYhq2h05V8HKROSO5ZstUVOsHy9X3kmwfUL2x6z52yc67CYdALFdHbItBtiHwcMdKigqnhs800oWdLxtrs"
);
let elements = stripe.elements();
let cardElement = elements.create("card");

export default {
  name: "Subscribe",
  components: {
    LottieAnimation,
    PlanContainer,
    MultiConnectVideo,
  },
  data() {
    return {
      monthlyPerCardPrice: currency(3.0),
      yearlyPerCardPrice: currency(28.8),
      promoCodeDialog: false,
      billingPeriodDialog: false,
      billingPeriod: "monthly",
      tab: 0,
      loadingDialog: false,
      loadingMessage: "",
      valid: false,
      businessName: "",
      businessNumber: "",
      businessLocation: "",
      selectedPlan: "evolve",
      selectPlanDialog: false,
      noOfEmployees: "",
      isFirstSubmissionAttempt: true,
      cardError: "",
      businessNameRules: [(v) => !!v || "Please enter your Business Name"],
      businessNumberRules: [
        (v) => !!v || "Please enter your Registered Business Number",
      ],
      businessLocationRules: [
        (v) => !!v || "Please enter your Business's Location",
      ],
      noOfEmployeesRules: [
        (v) => !!v || "This field is required",
        (value) =>
            this.removeCommas(value) > 0 ||
            "The business size needs to be a number greater than zero",
      ],
      noOfBusinessCardsRules: [
        (v) => !!v || "Please enter the total number of cards",
        (value) =>
            this.removeCommas(value) > 0 ||
            "The number of cards needs to be a number  greater than zero",
      ],
      promoCode: "",
      promoCodeObject: null,
      promoServerError: "",
      promoCodeLoading: false,
      inclusionIcon: "mdi-check-circle",
      businessCategory: "",
      businessCategoryRules: [(v) => !!v || "This field is required"],
      businessCategoryList: constants.BUSINESS_CATEGORY_LIST.sort(),
      showMCVideo: false,
      crmInclusionIcon: "mdi-circle-outline",
      hasRequestedCRMIntegration: false,
      isPartnerRepresentativeDocExists: false,
      partnerRepresentativePromoCode: "",
      partnerRepresentativeParentEventId: "",
    };
  },
  async created() {
    this.addCommas = Utility.addCommas;
    this.removeCommas = Utility.removeCommas;
    this.stripeToJSDate = Utility.stripeToJSDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
    this.businessName = this.businessProfile.businessName || "";
    this.businessNumber = this.businessProfile.businessNumber || "";
    this.businessCategory = this.businessProfile.businessCategory || "";
    // this.businessLocation = this.businessProfile.country || "";
    this.noOfEmployees = this.addCommas(
        this.businessProfile.noOfEmployees || ""
    );

    if (this.isPartnerRepresentative) {
      this.noOfEmployees = "1000";
    }

    this.selectedPlan = this.businessProfile.plan || "";
    this.selectedPlan = this.selectedPlan.toLowerCase();
    console.log("selectedPlan: ", this.selectedPlan);
    if (this.selectedPlan == "")
      this.selectedPlan = this.userProfile.subscriptionPreference || "grow";

    console.log("selectedPlan: ", this.selectedPlan);

    //Set the icon for MC add-on based on the selectedPlan
    this.inclusionIcon =
        this.selectedPlan == "evolve" ? "mdi-check-circle" : "mdi-circle-outline";

    console.log("plan", this.selectedPlan);

    // this.positionType = this.businessProfile.positionType || "";

    //Start: Retrieve users country from ipinfo
    try {
      let response = await axios.get(
          "https://ipinfo.io/json?token=ee24dead4cfb8d"
      );
      let country = this.telephoneCodes.find(
          (country) => country.countryCode == response.data.country
      );
      this.businessLocation = country.name;
    } catch (error) {
      console.log("error: ", error);
      this.businessLocation = this.businessProfile.country || "";
    }
    //End: Retrieve users country from ipinfo

    if (this.userProfile.partnerRepresentativeToken) {


      let collectionName = this.userProfile.promoterType == 'STARTUPS_AND_SCALE_UPS' ? 'featuredCompanies' : 'sponsors';

      //Get the partner rep from firestore
      let partnerRep = await getDocById(collectionName, this.userProfile.partnerRepresentativeToken);
      if (partnerRep.exists) {
        this.isPartnerRepresentativeDocExists = true;
        if (partnerRep.data().name) {
          this.businessName = partnerRep.data().name;
        }
        if (partnerRep.data().promoCode) {
          this.partnerRepresentativePromoCode = partnerRep.data().promoCode;
        }
        if (partnerRep.data().eventId) {
          this.partnerRepresentativeParentEventId = partnerRep.data().eventId;
        }
      }
    }

  },
  mounted() {
    if (this.currentPermission.privilegeLevel != "admin") return;
    let tabIndex = parseInt(this.$route.params.tabIndex);
    if (
        this.businessProfile.subscriptionStatus == "active" ||
        this.businessProfile.subscriptionStatus == "trialing" ||
        this.businessProfile.subscriptionStatus == "past_due"
    ) {
      this.$router.push("/");
      return;
    }

    if (tabIndex == 0) {
      this.tab = 0;
    } else if (tabIndex == 1) {
      if (this.$refs.initialBusinessProfileForm.validate()) this.tab = 1;
      else {
        this.$router.push({params: {tabIndex: 0}});
        this.tabIndex = 0;
      }
    }

    cardElement.mount(this.$refs.cardElement);
    cardElement.on("change", (event) => {
      this.showCardError(event);
    });
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    async presentpromoCodeDialog() {
      this.promoCode = "";
      this.promoServerError = "";
      this.promoCodeLoading = false;
      this.promoCodeDialog = true;
    },
    isPartnerRepresentative() {
      if (this.userProfile.partnerRepresentativeToken) {
        return true;
      } else {
        return false;
      }
    },
    removePromoCode() {
      this.promoCode = "";
      this.promoServerError = "";
      this.promoCodeLoading = false;
      this.promoCodeObject = null;
    },
    async applyPromoCode() {
      if (this.promoCode.trim() == "" || this.promoCodeLoading) {
        return;
      }
      this.promoCodeLoading = true;
      const getPromoCodeFromStripe = getHttpsCallable("getPromoCodeFromStripe");
      this.promoCodeObject = (
          await getPromoCodeFromStripe({promoCode: this.promoCode})
      ).data;
      console.log(this.promoCodeObject);
      if (this.promoCodeObject == null) {
        this.promoServerError = "Invalid promotion code.";
        this.promoCodeLoading = false;
      } else {
        this.promoCodeDialog = false;
        this.promoCodeLoading = false;
      }
    },
    handeRedirectToBusinessAccounts() {
      if (this.loggedInUsersPermissions.length > 1) {
        this.$router.push({name: "BusinessAccounts"});
      } else {
        this.$router.push({
          name: "BusinessAccounts",
          query: {create: true},
        });
      }
    },
    calculateYearlyPrice() {
      let priceForAdditionalBusinessCards = this.yearlyPerCardPrice.multiply(
          this.additionalBusinessCards
      );
      let totalPriceBeforeDiscount = this.yearlyBasePrice.add(
          priceForAdditionalBusinessCards
      );
      let discount = 0;

      if (
          this.promoCodeObject != null &&
          this.promoCodeObject.coupon.percent_off / 100 >
          this.volumeDiscount.ratio
      )
        discount = totalPriceBeforeDiscount.multiply(
            this.promoCodeObject.coupon.percent_off / 100
        );
      else
        discount = totalPriceBeforeDiscount.multiply(this.volumeDiscount.ratio);

      let totalPriceAfterDiscount = totalPriceBeforeDiscount.subtract(discount);

      //Apply GST if applicable
      let gst = 0;
      if (this.businessProfile.country == "Australia") {
        gst = totalPriceAfterDiscount.multiply(0.1);
      }
      let totalYearlyPrice = totalPriceAfterDiscount.add(gst);
      return totalYearlyPrice;
    },
    async saveInitialBusinessProfile() {
      if (this.$refs.initialBusinessProfileForm.validate()) {
        if (
            (
                this.businessProfile.stripeCustomerId == null ||
                this.businessProfile.stripeCustomerId == ""
            ) &&
            !this.isPartnerRepresentative()
        ) {

          console.log("addNewStripeCustomer called.");
          this.loadingMessage = "Setting up your Business Profile...";
          this.loadingDialog = true;
          //Call a cloud function to add/update a new stripe customer
          const addNewStripeCustomer = getHttpsCallable("addNewStripeCustomer");
          let stripeCustomer = await addNewStripeCustomer({
            name: this.businessName,
            stripeCustomerId: this.businessProfile.stripeCustomerId || "",
          });

          //Update the Business Profile
          await this.updateBusinessProfileDetails({
            businessName: this.businessName,
            businessNumber: this.businessNumber,
            country: this.businessLocation,
            // positionType: this.positionType,
            noOfEmployees: this.removeCommas(this.noOfEmployees),
            stripeCustomerId: stripeCustomer.data.stripeCustomerId,
            businessCategory: this.businessCategory,
            creationDate: new Date(),
          });
          this.loadingDialog = false;
        } else {

          if (this.isPartnerRepresentative())
            console.log("The customer is a Partner Representative. Skip addNewStripeCustomer call.");
          else
            console.log("Stripe customer already exists. Skip addNewStripeCustomer call.");

          //Do not create a new stripe customer just update the Business Profile
          await this.updateBusinessProfileDetails({
            businessName: this.businessName,
            businessNumber: this.businessNumber,
            // positionType: this.positionType,
            country: this.businessLocation,
            noOfEmployees: this.removeCommas(this.noOfEmployees),
            businessCategory: this.businessCategory,
          });
        }

        if (this.isPartnerRepresentative()) {
          try {
            this.loadingMessage = "Setting up your Business Profile...";
            this.loadingDialog = true;

            await this.updateBusinessProfileDetails({
              subscriptionStatus: "active",
              partnerRepresentativeToken: this.userProfile.partnerRepresentativeToken,
              partnerRepresentativeParentEventId: this.partnerRepresentativeParentEventId,
              promoterType: this.userProfile.promoterType || "",
              nextInvoiceCreationDate: new Date(),
              creationDate: new Date(),
            });

            await this.populateUsersFromEventbrite();

            let collectionName = this.userProfile.promoterType == 'STARTUPS_AND_SCALE_UPS' ? 'featuredCompanies' : 'sponsors';

            await updateDocByName(collectionName, this.userProfile.partnerRepresentativeToken, {
              status: 'Onboarded',
              businessProfileId: this.selectedBusinessProfileId,
            });

            this.$router.push("/");
          } catch (error) {
            console.log("Error occurred while setting up Partner Representative's Business Profile: ", error);
            this.loadingDialog = false;
          }

        } else {
          //Move to the payment tab
          this.$router.push({params: {tabIndex: 1}});
          this.tab = 1;
        }
      } else {
        this.isFirstSubmissionAttempt = false;
      }
    },
    showCardError(event) {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = "";
      }
    },
    handleSubscribe() {
      if (!this.$refs.businessSubscriptionForm.validate()) {
        console.log("businessSubscriptionForm is invalid. exit from method");
        return;
      }
      if (this.billingPeriod == "monthly") this.billingPeriodDialog = true;
      else this.subscribe();
    },
    switchToYearly() {
      this.billingPeriodDialog = false;
      this.billingPeriod = "yearly";
      this.subscribe();
    },
    subscribe() {
      //Create a new payment method
      this.billingPeriodDialog = false;
      this.loadingMessage = "Saving your payment details...";
      this.loadingDialog = true;
      stripe
          .createPaymentMethod({
            type: "card",
            card: cardElement,
          })
          .then((result) => {
            if (result.error) {
              this.cardError = error;
              this.loadingDialog = false;
            } else {
              this.createSubscription(result.paymentMethod.id);
            }
          })
          .catch(() => {
            this.loadingDialog = false;
          });
    },
    async createSubscription(paymentMethodId) {
      //Call a cloud function to attach the payment method to the stripe customer and start the subscription
      try {
        this.loadingMessage = "Starting your subscription...";
        const createSubscription = getHttpsCallable("createSubscription");
        let response = await createSubscription({
          stripeCustomerId: this.businessProfile.stripeCustomerId,
          plan: this.selectedPlan,
          paymentMethodId: paymentMethodId,
          quantity: this.additionalBusinessCards + 1,
          billingPeriod: this.billingPeriod,
          applyGST: this.businessProfile.country == "Australia" ? true : false,
          discountPercentage: this.volumeDiscount.percent,
          couponId:
              this.promoCodeObject != null &&
              this.promoCodeObject.coupon.percent_off / 100 >
              this.volumeDiscount.ratio
                  ? this.promoCodeObject.coupon.id
                  : "",
          trialPeriodDays: this.getTrialPeriodDays,
          firstName: this.userProfile.firstName,
          email: this.userProfile.email,
        });
        if (response.data.error != undefined) {
          this.cardError = response.data.error.message;
          this.loadingDialog = false;
        } else {
          await this.handlePaymentThatRequiresCustomerAction(response.data);
          await this.handleRequiresPaymentMethod(response.data);
          await this.onSubscriptionComplete(response.data);
        }
      } catch (error) {
        this.cardError = error;
        this.loadingDialog = false;
      }
    },
    async handlePaymentThatRequiresCustomerAction(subscription) {
      //To be implemented
    },
    async handleRequiresPaymentMethod(subscription) {
      //To be implemented
    },
    async onSubscriptionComplete(subscription) {
      if (
          subscription.status === "active" ||
          subscription.status === "trialing"
      ) {
        //Provision Business Portal Access
        //Update the Business Profile
        console.log("subscription object");
        console.log(subscription);
        await this.updateBusinessProfileDetails({
          subscriptionId: subscription.id,
          subscriptionStatus: subscription.status,
          productDescription: subscription.product_description,
          nextInvoiceAmount: subscription.upcoming_invoice.amount_due,
          nextInvoiceCreationDate: this.stripeToJSDate(
              subscription.upcoming_invoice.created
          ),
          lastFour: subscription.card.last4,
          paymentMethod: subscription.card.brand,
          paymentMethodExp:
              subscription.card.exp_month + "/" + subscription.card.exp_year,
          billingPeriod: this.billingPeriod,
          noOfEmployees: this.additionalBusinessCards + 1,
          trialPeriodDays: subscription.trial_period_days,
          plan: this.selectedPlan,
          hasRequestedCRMIntegration: this.hasRequestedCRMIntegration,
        });

        //Start: Upgrade user's existing Hatch card if required
        await this.upgradeUsersHatchCard();
        //End: Upgrade user's existing Hatch card if required

        //Send CRM integration request email
        try {
          if (this.hasRequestedCRMIntegration) {
            //Send email
            let emailData = {
              email: "connect@pappyon.com",
              businessName: this.businessProfile.businessName,
              loggedInUsersUid: this.loggedInUsersUid,
              firstName: this.userProfile.firstName,
              lastName: this.userProfile.lastName,
              userEmail: this.userProfile.email,
              selectedBusinessProfileId: this.selectedBusinessProfileId,
            };

            const sendEmail = getHttpsCallable("sendCRMIntegrationRequestEmail");
            await sendEmail(emailData);
          }
        } catch (error) {
          console.log("Error occurred while sending CRM Request: ", error);
        }

        this.loadingDialog = false;

        //Start: create a trigger to send welcome email to admin
        // await this.createWelcomeEmailTrigger();
        this.$router.push("/");
      }
    },

    async populateUsersFromEventbrite() {
      if (this.partnerRepresentativePromoCode) {
        let eventbriteUsers = [];
        try {

          //Remove all the spaces from the promo code and then split it based on the delimiter "," to get multiple promocodes
          let promoCodes = this.partnerRepresentativePromoCode.replace(/\s/g, "").split(",");


          //get the document from firestore from the collection "eventbrite_data" with the document id "eventbrite_data"
          //Get the docs from the collection "eventbrite_data" where the property "promoCode" is equal to the promo code provided by the partner representative
          let querySnapshot = await getQueryByCollectionName("eventbrite_data", where("promoCode", "in", promoCodes));


          querySnapshot.forEach((attendeeDocument) => {
            let attendee = attendeeDocument.data();
            if (attendee.first_name && attendee.last_name && attendee.email && attendee.jobTitle && attendee.mobile) {

              let mobile = attendee.mobile;
              //Remove every charecter that is not a number or a "+" sign
              mobile = mobile.replace(/[^0-9+]/g, "");

              //If the mobile number starts with "04" or "+614" the remove the first "0" and remove "+61" at the beginning of the number
              if (mobile.startsWith("04") || mobile.startsWith("+614")) {
                mobile = mobile.replace(/^0+/, "");
                mobile = mobile.replace("+61", "");
              } else {
                mobile = "";
              }

              eventbriteUsers.push({
                firstName: attendee.first_name,
                lastName: attendee.last_name,
                email: attendee.email,
                jobTitle: attendee.jobTitle,
                mobile: mobile,
              });
            }
          });

        } catch (error) {
          console.log("Error occurred while retrieving users from Eventbrite: ", error);
        }

        try {
          const db = getFirestore();
          //For each user, create a new business card document in firestore and set the status of the business card to "Outstanding" and the businessProfileId to the newly created business profile's id.
          //Perform the add documents for each users in a batch
          const batch = writeBatch(db);
          eventbriteUsers.forEach((user) => {
            let businessCardRef = doc(getCollectionRef("business_cards"));
            batch.set(businessCardRef, {
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              jobTitle: user.jobTitle,
              mobile: user.mobile,
              status: "Outstanding",
              businessProfileId: this.selectedBusinessProfileId,
              subscriptionType: "GROW",
            });
          });

          //Commit the batch
          await batch.commit();
        } catch (error) {
          console.log("Error occurred while creating business cards for users from Eventbrite: ", error);
        }

      }
    },

    async upgradeUsersHatchCard() {
      try {
        let upgradeToBusinessPlan =
            this.userProfile.upgradeToBusinessPlan || false;
        if (upgradeToBusinessPlan) {
          //Get the users Avtive Hatch business cards
          let querySnapshot = await getQueryBusinessCardsCollection(
              where("uid", "==", this.loggedInUsersUid),
              where("subscriptionType", "==", "HATCH"),
              where("status", "==", "Active"),
          );
          if (querySnapshot.docs.length == 1) {
            console.log("The users has exactly 1 Active Hatch card");
            //Start: Update all permisions to true
            let permissions = querySnapshot.docs[0].data().permissions;
            for (var prop in permissions) {
              if (Object.prototype.hasOwnProperty.call(permissions, prop)) {
                permissions[prop] = true;
              }
            }
            //End: Update all permissions to true

            //Updgrade the Hatch card to a Grow card
            console.log("Upgraging the user's Hatch card...");
            await updateBusinessCardsDoc(querySnapshot.docs[0].id, {
              subscriptionType: "GROW",
              businessProfileId: this.userProfile.businessProfileId,
              businessName: this.businessProfile.businessName,
              permissions: permissions,
            });
            await updateUserDoc(this.loggedInUsersUid, {
              upgradeToBusinessPlan: false,
            });
            console.log("Upgraged successfully!");
          }
        }
      } catch (error) {
        console.log("Error while ppgrading user's existing Hatch");
        console.log(error);
      }
    },
    handleBackClick() {
      this.$router.go(-1);
      this.tab = 0;
    },

    selectGrowPlan() {
      this.selectedPlan = "grow";
      this.selectPlanDialog = false;
    },

    selectEvolvePlan() {
      this.selectedPlan = "evolve";
      this.selectPlanDialog = false;
    },
    async createWelcomeEmailTrigger() {
      try {
        //Calculate trigger time to run
        let now = new Date();
        let timeToRun = new Date(now.setMinutes(now.getMinutes() + 30));

        let eventTrigger = new EventTrigger({
          hasRun: false,
          message: "Welcome to your new business profile",
          type: constants.BUSINESS_PROFILE_CREATED,
          timeToRun: timeToRun,
          businessProfileId: this.userProfile.businessProfileId,
          userName: this.userProfile.firstName,
          email: this.userProfile.email,
        });

        await eventTrigger.save();
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    handleInclusionClick() {
      if (this.inclusionIcon == "mdi-circle-outline") {
        this.inclusionIcon = "mdi-check-circle";
        this.selectEvolvePlan();
      } else {
        this.inclusionIcon = "mdi-circle-outline";
        this.selectGrowPlan();
      }
    },
    handleCRMInclusionClick() {
      if (this.crmInclusionIcon == "mdi-circle-outline") {
        this.hasRequestedCRMIntegration = true;
        this.crmInclusionIcon = "mdi-check-circle";
      } else {
        this.hasRequestedCRMIntegration = false;
        this.crmInclusionIcon = "mdi-circle-outline";
      }
    },
  },
  computed: {
    ...mapGetters([
      "businessProfile",
      "userProfile",
      "countryList",
      "currentPermission",
      "loggedInUsersPermissions",
      "telephoneCodes",
      "loggedInUsersUid",
      "selectedBusinessProfileId",
    ]),
    selectedPlanName() {
      return this.getSubscriptionPlanTitle(this.selectedPlan);
    },
    mcAddOnRate() {
      if (this.billingPeriod == "monthly") return currency(10.0);
      else return currency(96.0);
    },
    basePriceToPreview() {
      if (this.billingPeriod == "monthly") return currency(19.95);
      else return currency(191.52);
    },
    monthlyBasePrice() {
      console.log("plan: ", this.selectedPlan);
      if (this.selectedPlan == "evolve") return currency(29.95);
      else return currency(19.95);
    },
    yearlyBasePrice() {
      if (this.selectedPlan == "evolve") return currency(287.52);
      else return currency(191.52);
    },
    additionalBusinessCards() {
      if (this.removeCommas(this.noOfEmployees) > 0)
        return this.removeCommas(this.noOfEmployees) - 1;
      else return 0;
    },
    getTrialPeriodDays() {
      if (
          this.promoCodeObject != null &&
          ["BIH90DAYS", "STAIRWAY90DAYS"].includes(this.promoCodeObject.code)
      )
        return 0;
      if (
          this.promoCodeObject != null &&
          [
            "SL3060",
            "GROW3060",
            "GROW4060",
            "GROW5060",
            "GROW100",
            "VIP5060",
            "CEOI100",
          ].includes(this.promoCodeObject.code)
      )
        return 60;
      return 30;
    },
    plan() {
      if (this.billingPeriod == "monthly") {
        return {
          basePrice: this.monthlyBasePrice,
          perCardPrice: this.monthlyPerCardPrice,
        };
      } else {
        return {
          basePrice: this.yearlyBasePrice,
          perCardPrice: this.yearlyPerCardPrice,
        };
      }
    },
    filteredLoggedInUsersPermissions() {
      return this.loggedInUsersPermissions.filter(
          (permission) => permission.businessName != ""
      );
    },
    totalPrice() {
      let total = this.totalPriceAfterDiscount;
      //Apply GST for Australian businesses
      if (this.businessProfile.country == "Australia") {
        total = total.add(this.gst);
      }
      return total;
    },
    gst() {
      return this.totalPriceAfterDiscount.multiply(0.1);
    },
    totalPriceAfterDiscount() {
      let total = this.totalPriceBeforeDiscount;
      //Apply any applicable volume discount
      total = total.subtract(this.discountAmount);
      return total;
    },
    discountAmount() {
      if (
          this.promoCodeObject != null &&
          this.promoCodeObject.coupon.percent_off / 100 >
          this.volumeDiscount.ratio
      )
        return this.totalPriceBeforeDiscount.multiply(
            this.promoCodeObject.coupon.percent_off / 100
        );
      else
        return this.totalPriceBeforeDiscount.multiply(
            this.volumeDiscount.ratio
        );
    },
    totalPriceBeforeDiscount() {
      let priceForAdditionalBusinessCards = this.plan.perCardPrice.multiply(
          this.additionalBusinessCards
      );
      let total = this.plan.basePrice.add(priceForAdditionalBusinessCards);
      return total;
    },
    volumeDiscount() {
      if (this.noOfEmployees <= 29)
        return {startInterval: 0, endInterval: 29, percent: 0, ratio: 0};
      else if (this.noOfEmployees >= 30 && this.noOfEmployees <= 50)
        return {startInterval: 30, endInterval: 50, percent: 30, ratio: 0.3};
      else if (this.noOfEmployees >= 51 && this.noOfEmployees <= 80)
        return {startInterval: 51, endInterval: 80, percent: 35, ratio: 0.35};
      else if (this.noOfEmployees >= 81)
        return {startInterval: 81, endInterval: -1, percent: 40, ratio: 0.4};
      else return {startInterval: 0, endInterval: 29, percent: 0, ratio: 0};
    },
    freeTrialEndDate() {
      let endDate = new Date(
          new Date().setDate(new Date().getDate() + this.getTrialPeriodDays)
      )
          .toLocaleString()
          .split(",")[0];

      return endDate;
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      let tabIndex = parseInt(to.params.tabIndex);
      if (this.tab != tabIndex) {
        if (
            this.businessProfile.subscriptionStatus == "active" ||
            this.businessProfile.subscriptionStatus == "trialing" ||
            this.businessProfile.subscriptionStatus == "past_due"
        ) {
          //If the subscription is active ensure that the user cannot access this 0 page
          this.$router.push("/");
          return;
        }

        if (tabIndex == 0) {
          this.tab = 0;
        } else if (tabIndex == 1) {
          if (this.$refs.initialBusinessProfileForm.validate()) this.tab = 1;
          else {
            this.$router.push({params: {tabIndex: 0}});
            this.tabIndex = 0;
          }
        }
      }
    },
    noOfEmployees: function (newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.noOfEmployees = result;
    },
  },
};
</script>
<style scoped>
/deep/ .right-aligned-input input {
  text-align: right;
}
</style>
